module.exports = "::ng-deep .cdk-overlay-pane {\n  background-color: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor/my-vendor/vendor-statement/vendor-statement.component.scss
// module id = ./src/app/pages/vendor/my-vendor/vendor-statement/vendor-statement.component.scss
// module chunks = main